import { useClientTranslation } from '@/lib/core/i18n';
import { Icon } from '@/components/ui/icon';

interface BookmarkButtonProps {
  isBookmarked: boolean;
  onBookmark: () => void;
}

export function BookmarkButton({ isBookmarked, onBookmark }: BookmarkButtonProps) {
  const t = useClientTranslation();

  return (
    <button
      type="button"
      className="shrink-0"
      onClick={e => {
        e.stopPropagation();
        onBookmark();
      }}
      aria-label={isBookmarked ? t('App.Labels.RemovePreference') : t('App.Labels.AddPreference')}
    >
      <Icon
        name={isBookmarked ? 'bookmark-solid' : 'bookmark'}
        width={24}
        height={24}
        className="text-jncquoi-neutral-1000"
      />
    </button>
  );
}
